import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import CryptoJS from "crypto-js";
import classNames from "classnames";
import { Field, Form, Formik } from "formik";
import { Modal } from "../../../molecules";
import { actions as modalActions } from "../../Modal/modal.reducers";
import { MODAL_SIZE } from "../modals.constants";
import { updateUserProfile, selectUser } from "../../../../pages/UserProfile";
import { EMPTY_STRING } from "../../../../constants";
const { setSelectedModal } = modalActions;
const { MD } = MODAL_SIZE;

const DevConsoleModal = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectUser);
  const handleClose = useCallback(() => {
    dispatch(setSelectedModal());
  }, [dispatch]);

  const handleOnSubmit = useCallback(
    ({ deployToken }) => {
      const encryptedKey = CryptoJS.AES.encrypt(
        deployToken,
        process.env.REACT_APP_SECRET_PASS
      ).toString();
      dispatch(
        updateUserProfile({
          user: { deployToken: encryptedKey },
          id: currentUser.id,
        })
      );
      handleClose();
    },
    [currentUser, dispatch, handleClose]
  );

  return (
    <Formik
      enableReinitialize
      onSubmit={handleOnSubmit}
      validateOnMount={true}
      initialValues={{ deployToken: EMPTY_STRING }}
    >
      {({
        values,
        handleSubmit,
        handleChange,
        handleBlur,
        handleReset,
        touched,
        errors,
      }) => {
        const footer = (
          <div className="p-6 border-t border-gray-700 flex align-center justify-end">
            <button
              type="button"
              className="btn btn-primary-light mr-1"
              onClick={() => {
                handleReset();
                dispatch(setSelectedModal());
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              className="btn btn-primary"
            >
              Save
            </button>
          </div>
        );

        return (
          <Modal
            title="Add token"
            subtitle="Add token to deploy the app"
            handleReset={handleReset}
            handleClose={handleClose}
            size={MD}
            footer={footer}
          >
            <Form>
              <div className="modal-body p-6 space-x-2">
                <div className="space-y-4">
                  <div className="form-group">
                    <label className="text-sm font-medium text-gray-50 mb-1 block">
                      Enter Github Token
                    </label>
                    <Field
                      type="password"
                      className={classNames("form-control border-2", {
                        "border-red-600":
                          touched.deployToken && errors.deployToken,
                      })}
                      placeholder="Token"
                      name="deployToken"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.deployToken && errors.deployToken && (
                      <div className="text-sm font-medium text-red-500 ">
                        {errors.deployToken}
                      </div>
                    )}
                  </div>
                  <div className="border rounded bg-orange-200 text-amber-700 font-medium p-3 text-sm m-1 border-orange-700">
                    Note: On updating the token, the previously added one will
                    become invalidated and be replaced by the new token.
                  </div>
                </div>
              </div>
            </Form>
          </Modal>
        );
      }}
    </Formik>
  );
};

export default DevConsoleModal;
